import React from 'react';
import Image from 'next/image';
import styles from './pdp-bike-info.module.scss';
import Media from '../../../models/media';

type Props = {
  numberOfStars: number;
  rating: string;
  reviews: string;
  starIcon: Media | undefined;
  title: string;
};

const PDPBikeInfo = ({
  title,
  rating,
  reviews,
  numberOfStars,
  starIcon
}: Props) => {
  const ratingText = rating ? `${rating}/5` : '';
  const reviewText = reviews ? `${reviews} reviews` : '';

  return (
    <div className={styles['pdp-bike-info__info-container']}>
      <p className={styles['pdp-bike-info__product-title']}>{title}</p>
      <div className={styles['pdp-bike-info__info-line-2']}>
        <div className={styles['pdp-bike-info__star-container-row']}>
          {starIcon &&
            new Array(numberOfStars).fill(0).map((index: number) => (
              <div
                key={`${starIcon.alt}-${index}`}
                className={styles['pdp-bike-info__star-image-container']}
              >
                <Image
                  alt={starIcon.alt}
                  className={styles['pdp-bike-info__star-image']}
                  height={starIcon.height}
                  src={starIcon.src}
                  width={starIcon.width}
                />
              </div>
            ))}
        </div>
        <div className={styles['pdp-bike-info__rating-text']}>
          <span className={styles['pdp-bike-info__rating']}>{ratingText}</span>
          <span className={styles['pdp-bike-info__review']}>{reviewText}</span>
        </div>
      </div>
    </div>
  );
};

export default PDPBikeInfo;
